module.exports = __webpack_public_path__ + "img/cash.f7313878.png";